<div class="pointer flex flex-row" (click)="onValueChange($event)">
    <label class="switch" [class.checked]="value">
      <span class="slider round"></span>
    </label>

    <span class="onoff-label" *ngIf="value && onLabel">{{ onLabel }}</span>
    <span class="onoff-label" *ngIf="!value && offLabel">{{ offLabel }}</span>

</div>
